/**
 * @desc 获取订单已退款明细
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.getCompleteRefundDetails.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getCompleteRefundDetails`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
